import React from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";
import RegistrationForm from "./RegistrationForm/RegistrationForm";
import RegistrationResponse from "./RegistrationResponse/RegistrationResponse";

const RegistrationPage = () => {
  const status = useSelector(
    (state) => state.registration.status
  );

  return (
    <>
      {(status === "idle" || status === "pending") && <RegistrationForm />}
      {status === "done" && <RegistrationResponse />}
    </>
  );
};

export default RegistrationPage;
